/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Edit_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update user. Please try again." |
*
* @param {Members_Edit_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_edit_error = /** @type {((inputs?: Members_Edit_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Edit_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update user. Please try again.")
});